import React, { useState } from 'react';

import { Stack } from '../stack/stack';

interface Props<T> {
  onChange: (value: T) => void;
  items: { value: T; name: string }[];
  disabled?: boolean;
}

export function RadioButtons<T extends string>(props: Props<T>) {
  const [value, setValue] = useState(props.items[0].value);

  const onClick = (value: T) => () => {
    setValue(value);
    props.onChange(value);
  };

  return (
    <Stack direction="column" spacing={0.5}>
      {props.items.map((x, idx) => (
        <Stack direction="row" key={idx} spacing={0.2}>
          <input
            checked={value === x.value}
            disabled={props.disabled}
            type="radio"
            value={x.value}
            onChange={onClick(x.value)}
          />
          <label onClick={onClick(x.value)}>{x.name}</label>
        </Stack>
      ))}
    </Stack>
  );
}
